import axios from '../requester';
import { API } from '../constants/api-urls';

export const getIncidents = async params =>
  axios.post(API.METRICS_SEARCH_INCIDENTS, params);
